import { RowAction, TableRowActions } from "@/components/ui/table-row-actions";
import { RowData } from "@tanstack/react-table";
import { RowWithIdentifier } from "../_helpers/row-identifier";
import { DataTableRow, ImplementedDisplayColumnDef } from "../types";

export const createActionsColumn = <TData extends RowData & RowWithIdentifier, TValue = unknown>(
  rowActions: (row: DataTableRow<TData>) => RowAction[],
): ImplementedDisplayColumnDef<TData, TValue> => ({
  id: "actions",
  size: 50,
  header: "",
  enableSorting: false,
  cell: ({ row }) => {
    const actions = rowActions(row);
    if (actions.length === 0) return null;

    return <TableRowActions actions={actions} />;
  },
});
